// Bayi sözleşme ve belge onayı akışı.
// Backend PascalCase döner (Startup.cs -> PropertyNamingPolicy = null).

/** TableDealerContract.Status */
export enum DealerContractStatus {
  /** Bilgi/belge/sözleşme tamamlanmadı. Site kapalı. */
  Beklemede = 0,
  /** Bayi tamamladı, admin incelemesi bekliyor. Site açık. */
  IncelemeBekliyor = 1,
  /** Admin onayladı. Site açık. */
  Onaylandi = 2,
  /** Admin reddetti. Site kapalı. */
  Reddedildi = 3,
  /** Red sonrası bayi düzeltti, admin incelemesi bekliyor. Site kapalı. */
  DuzeltmeIncelemeBekliyor = 4,
}

/** Adminin red kapsamı. Bilgi içeren kapsamlarda sözleşme yeniden onaylatılır. */
export enum DealerContractRejectScope {
  Belge = 1,
  Bilgi = 2,
  BelgeVeBilgi = 3,
}

/** Backend'in ürettiği modal adımı. */
export type DealerContractStep = 'form' | 'contract' | 'documents' | 'wait' | 'representative'

/** Belge etiketleri — backend bu sabitleri bekliyor, dosya adı olarak da kullanılıyor. */
export const DEALER_CONTRACT_DOCUMENT_KEYS = {
  ImzaSirkusu: 'ImzaSirkusu',
  VergiLevhasi: 'VergiLevhasi',
} as const

export type DealerContractDocumentKey = keyof typeof DEALER_CONTRACT_DOCUMENT_KEYS

/** TableDealers kaynaklı, bayinin değiştiremediği bilgiler. */
export interface IDealerContractDealerInfo {
  DealerSapCode: string
  CompanyName: string
  Address: string
  TaxOrTcNumber: string
  TaxAdministration: string
  Email: string
  MobilePhone: string
}

/** Bayiden istenen alanlar. */
export interface IDealerContractInfo {
  AuthorizedNameSurname: string
  /** TableDealers.TaxNumber ile ön-dolu gelir, bayi düzeltebilir. */
  AuthorizedTc: string
  MersisNo: string
  HasNoMersis: boolean
  /** TableDealers.Mail ile ön-dolu gelir, bayi düzeltebilir. Zorunlu. */
  Email: string
  /**
   * TableDealers.Phone1..4 içindeki cep numarasıyla ön-dolu gelir, bayi düzeltebilir.
   * SMS doğrulama kodu bu numaraya gider. Zorunlu.
   */
  MobilePhone: string
  CommercialMessage: boolean
  /** KVKK aydınlatma metni onayı. Zorunlu — onaysız gönderim backend'de reddedilir. */
  KvkkApproval: boolean
}

export interface IDealerContractDocument {
  Name: string
  FileName: string
  FileUrl: string
}

/** GET homepage/IsContractPopup — popup gerekmiyorsa null döner. */
export interface IDealerContractPopup {
  Show: boolean
  Step: DealerContractStep
  Status: DealerContractStatus
  RejectScope?: DealerContractRejectScope | null
  RejectReason?: string | null
  RejectDate?: string | null
  SiteAccess: boolean
  /** Cep telefonu çözülemediyse SMS adımı geçilemez; temsilciye yönlendirilir. */
  CanSendSms: boolean
  Message?: string | null
  /**
   * TableDealers'taki eksik zorunlu alanlar. Boş değilse akış ilerletilemez
   * (Step = 'representative'); bayi temsilcisiyle iletişime geçmek zorundadır.
   */
  MissingDealerFields: string[]
  Dealer: IDealerContractDealerInfo
  Info: IDealerContractInfo
  Documents: IDealerContractDocument[]
  ContractFileUrl?: string | null
  ContractVersion?: string | null
}

/** POST homepage/contract/save-info isteği. */
export interface IDealerContractInfoRequest {
  AuthorizedNameSurname: string
  AuthorizedTc: string
  MersisNo: string
  HasNoMersis: boolean
  Email: string
  MobilePhone: string
  CommercialMessage: boolean
  KvkkApproval: boolean
}

/** POST homepage/contract/save-info yanıtı. */
export interface IDealerContractSaveInfoResponse {
  ContractFileUrl: string
  CanSendSms: boolean
}

/** Backend Core.Models.File.FileModel karşılığı. */
export interface IDealerContractFile {
  Label: string
  Content: string
  Extension: string
  FileType: string
}

export interface IDealerContractDocumentUploadRequest {
  Files: IDealerContractFile[]
}

export interface IDealerContractConfirmRequest {
  SmsCode: string
}

export interface IDealerContractConfirmResponse {
  Status: DealerContractStatus
  SiteAccess: boolean
}
